export default "/images/50b53915c0ae7df9704e03d13a54fc65.avif";